import { compose, bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import componentCanCrash from '../../utils/components/componentCanCrash'
import userHasCustomTourOperatorsOverwrite from '../../utils/tourOperators/userHasCustomTourOperatorsOverwrite'

import {
  v1requestUser,
  v1requestChangeUserCustomTOPCode,
} from '../../actions/users'
import {
  v1requestTourOperators,
  v1requestFilteredTourOperators,
} from '../../actions/tourOperators'

import TourOperatorSelector from '../../components/TourOperatorSelector'

export const mapStateToProps = state => {
  return {
    showTourOperatorSelector: userHasCustomTourOperatorsOverwrite(),
    tourOperators: [
      ...state.v1tourOperators.items.map(tourOperator => ({
        value: tourOperator.code,
        label: `${tourOperator.code} - ${tourOperator.name} (${
          tourOperator.market
        })`,
      })),
    ],
    userTourOperatorCode: state.v1user.customTOPCode || state.v1user.topCode,
    fetchTourOperators:
      state.v1tourOperators &&
      !state.v1tourOperators.isRequestCompleted &&
      !state.v1tourOperators.isFetching,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      requestTourOperators: v1requestTourOperators,
      requestUser: v1requestUser,
      requestChangeUserCustomTOPCode: v1requestChangeUserCustomTOPCode,
      requestFilteredTourOperators: v1requestFilteredTourOperators,
    },
    dispatch
  )

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  componentCanCrash
)(TourOperatorSelector)
